import { render } from "./StakeModal.vue?vue&type=template&id=64559ae4"
import script from "./StakeModal.vue?vue&type=script&lang=js"
export * from "./StakeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__